<template>
  <article class="user_view">
    <left-menu/>
    <select-device @cancel="onCancel" :typeSelection="'single'" :company="selectedCompany" @select="onSelect" v-if="showModal"/>
    <section class="new_user">
      <div @click="$router.push({ name: 'Guards' })" class="back_button">
        <img src="./../../assets/img/icons/back-button.svg">
        <span>atrás</span>
      </div>
      <section class="new_user__form">
        <h1> Editar guarda </h1>
        <div class="new_user__form--input-sec">
          <div class="form_input">
            <label>Nombre*</label>
            <input v-model="user.name" placeholder="Nombre"/>
          </div>
          <div class="form_input">
            <label>Apellido*</label>
            <input v-model="user.lastName" placeholder="Apellido"/>
          </div>
          <div class="form_input">
            <label>Número de cédula*</label>
            <input  v-model="user.cc" type="number" @input="equals?changeID():''" placeholder="Número de cédula"/>
          </div>
          <!--div class="form_input">
            <label>Dispositivo</label>
            <input v-model="user.device" @click="showModal = true" placeholder="Seleccione"/>
          </div-->
          <div class="form_input">
            <label>ID Carné</label>
            <input v-model="user.id" type="number" @change="equals=false" placeholder="Id carné"/>
          </div>
          <div class="form_input" v-if="getRol() == 'admin' || getRol() == 'coord'">
            <label>Empresa *</label>
            <input style="cursor: pointer;" v-model="user.company" @click="showModal = true" placeholder="Seleccione empresa"/>
          </div> 
          
        </div>
        <div style="margin-bottom:10px">
          <h5  class="login__sect-right__form--error">{{errorMessage}}</h5> 
        </div>
        <button class="secondary_button" @click.prevent="editGuard" :class="{'click':isCreated,'active': isComplete()}" :style="{width: '160px', height:'46px'}">GUARDAR</button>
      </section>
    </section>
  </article>
</template>

<script>

export default {
  props:{
    guard:{
      type: Object,
    }
    
  },
  data(){
    return{
      isCreated:false,
      errorMessage:"",
      user: {
        name: '',
        lastName: '',
        cc: '',
        id: '',
        company:''
      },
      showModal: false,
      selectedCompany:{
        id: null,
        name: null
      },
      equals:false,
    }
  },
  
  methods:{
      editGuard(){
        this.isCreated=true;  
        setTimeout(() => { this.isCreated=false; }, 200);
        const customActions={
            edit: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'PATCH'}                   
        };
        this.resource= this.$resource('guards/dashboard/' + this.$route.params.id,{},customActions);
        this.resource.edit({
          "user": {"id_card": this.user.cc, "card_company": this.user.id,"name": this.user.name, "last_name": this.user.lastName},
          company_id: this.user.company == null ? null : this.selectedCompany.id
        })
        .then(function(data){
          this.$router.push({ name: 'Guards' });
        }).catch(function(err){
          
          if(err.body.errors){
            this.errorMessage=err.body.errors
          }else{
            var errorlog=Object.keys(JSON.parse(err.bodyText).errors)[0];
            if (JSON.parse(err.bodyText).errors[errorlog][0]){
              if(JSON.parse(err.bodyText).errors[errorlog][0]=="has already been taken"){
                this.errorMessage="El número de cedula ya se encuentra registrado"             
              }else{
                this.errorMessage=JSON.parse(err.bodyText).errors[errorlog][0];
              }
            }else{
              this.errorMessage="Ha ocurrido un error en la edición, intentelo de nuevo"
            }
          }
        });
      },
      isComplete(){
        if(this.user.name!='' && this.user.lastName!='' && this.user.cc!='' && this.user.email!='' && this.user.id!=''){
          return true;
        }
      },
      onCancel(value){
        this.showModal = value;
      },
      onSelect(value){
        this.showModal = false;
        this.selectedCompany =value;
        this.user.company = value.name;
        
      },
      changeID(){
        this.user.id=this.user.cc;
      }
  },
  created(){
      const customActions={
          get: {headers:{"Authorization": 'Bearer '+localStorage.getItem('crypto')},method: 'GET'}                   
      };
      this.resource= this.$resource('guards/dashboard/show/',{},customActions);
      this.resource.get({"id_card": this.$route.params.id})
      .then(function(data){
        console.log(data)
        this.user.name = data.body.user.name;
        this.user.lastName = data.body.user.last_name;
        this.user.cc = data.body.user.id_card;
        this.user.id = data.body.user.card_company;
        this.user.company = data.body.company.name;
        this.selectedCompany = data.body.company;
        if(this.user.cc==this.user.id){
          this.equals=true;
        }
      });

      
      
      
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/EditGuard.vue